"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconSongs = Experimental__IconSongs;
exports.IconSongs = IconSongs;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * @deprecated IconSongs is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function IconSongs(props) {
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M9.008 1.135l5.246 3.024-.508.873-3.738-2.167.008 9.635A2.495 2.495 0 017.517 15a2.408 2.408 0 01-1.766-.734 2.411 2.411 0 01-.735-1.766c0-.688.245-1.277.734-1.766A2.408 2.408 0 017.516 10c.545 0 1.045.17 1.5.508l-.008-9.373zM6.456 13.56c.293.293.648.44 1.064.44a1.44 1.44 0 001.06-.44c.29-.294.436-.647.436-1.06 0-.413-.146-.766-.437-1.06A1.435 1.435 0 007.52 11a1.45 1.45 0 00-1.063.44c-.293.294-.44.647-.44 1.06 0 .413.147.766.44 1.06h-.001z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M13.386 2.56l7.213 4.159-.698 1.2-5.14-2.98.011 13.248a3.432 3.432 0 01-1.71 2.974 3.35 3.35 0 01-1.726.464 3.31 3.31 0 01-2.428-1.01 3.315 3.315 0 01-1.011-2.427 3.31 3.31 0 011.01-2.429 3.31 3.31 0 012.428-1.009 3.38 3.38 0 012.062.698l-.011-12.887zM9.877 19.646c.403.403.891.605 1.463.605.571 0 1.057-.202 1.457-.605.4-.404.6-.89.6-1.457 0-.568-.2-1.054-.6-1.458a1.973 1.973 0 00-1.457-.605c-.57 0-1.057.202-1.462.605a1.99 1.99 0 00-.605 1.457c0 .568.202 1.054.605 1.458h-.001z\'/>'
  }];
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = props.autoMirror || false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated IconSongs is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function Experimental__IconSongs(props) {
  return /*#__PURE__*/_react["default"].createElement(IconSongs, props);
}